// Contenido de los documentos legales. Se muestran en un modal desde el footer
// y en las páginas /terms y /privacy. Bilingüe ES/EN.
import { TERMS_ES, TERMS_EN } from "./legalTerms";

export const LEGAL = {
  // Contrato completo del estudio (transcrito literalmente de los documentos del
  // cliente; requerido para el registro como Health Studio en Florida).
  terms: {
    es: {
      title: "Contrato de Servicios, Exención y Términos",
      updated: "APEX RIDE BY GYA, LLC · Vigente desde agosto 2026",
      sections: TERMS_ES,
    },
    en: {
      title: "Services Agreement, Waiver & Terms",
      updated: "APEX RIDE BY GYA, LLC · Effective August 2026",
      sections: TERMS_EN,
    },
  },

  privacy: {
    es: {
      title: "Política de Privacidad",
      updated: "Última actualización: julio 2026",
      sections: [
        { h: "Datos que recopilamos", body: "Recopilamos el nombre, el correo electrónico y (opcionalmente) el número de móvil que nos proporcionas al crear una cuenta o reservar una clase." },
        { h: "Uso de tus datos", body: "Usamos tus datos para gestionar tus reservas y tu membresía, enviarte confirmaciones y recibos, y mantener tu historial de clases y recompensas." },
        { h: "Almacenamiento y seguridad", body: "Tus contraseñas se guardan cifradas y nunca en texto plano. Conservamos tus datos solo mientras tu cuenta esté activa." },
        { h: "Comunicaciones", body: "Si te suscribes al newsletter, podrás recibir novedades del estudio. Puedes darte de baja en cualquier momento." },
        { h: "Tus derechos", body: "Puedes acceder, corregir o solicitar la eliminación de tus datos escribiéndonos a apexridecyclingindoor@gmail.com." },
        { h: "Cookies", body: "Usamos almacenamiento local mínimo para mantener tu sesión y tu idioma; no utilizamos cookies de rastreo publicitario." },
      ],
    },
    en: {
      title: "Privacy Policy",
      updated: "Last updated: July 2026",
      sections: [
        { h: "Data we collect", body: "We collect the name, email and (optionally) mobile number you provide when creating an account or booking a class." },
        { h: "How we use your data", body: "We use your data to manage your bookings and membership, send confirmations and receipts, and keep your class history and rewards." },
        { h: "Storage & security", body: "Your password is stored encrypted and never in plain text. We keep your data only while your account is active." },
        { h: "Communications", body: "If you subscribe to the newsletter, you may receive studio updates. You can unsubscribe at any time." },
        { h: "Your rights", body: "You can access, correct or request deletion of your data by writing to apexridecyclingindoor@gmail.com." },
        { h: "Cookies", body: "We use minimal local storage to keep your session and language; we do not use advertising tracking cookies." },
      ],
    },
  },

  accessibility: {
    es: {
      title: "Accesibilidad",
      updated: "Última actualización: julio 2026",
      sections: [
        { h: "Nuestro compromiso", body: "Queremos que Apex Ride sea disfrutable por la mayor cantidad de personas posible, incluidas aquellas con discapacidad." },
        { h: "Estándares", body: "Trabajamos para alinear el sitio con las pautas WCAG 2.1 (nivel AA): contraste de color, navegación por teclado, textos alternativos y etiquetas accesibles." },
        { h: "Funciones", body: "El sitio es responsive, bilingüe (español/inglés) y usa marcado semántico para lectores de pantalla." },
        { h: "¿Encontraste una barrera?", body: "Si tienes dificultades para usar alguna parte del sitio, escríbenos a apexridecyclingindoor@gmail.com y lo resolveremos lo antes posible." },
      ],
    },
    en: {
      title: "Accessibility",
      updated: "Last updated: July 2026",
      sections: [
        { h: "Our commitment", body: "We want Apex Ride to be enjoyable for as many people as possible, including those with disabilities." },
        { h: "Standards", body: "We work to align the site with WCAG 2.1 (level AA): color contrast, keyboard navigation, alternative text and accessible labels." },
        { h: "Features", body: "The site is responsive, bilingual (Spanish/English) and uses semantic markup for screen readers." },
        { h: "Found a barrier?", body: "If you have difficulty using any part of the site, write to us at apexridecyclingindoor@gmail.com and we will address it as soon as possible." },
      ],
    },
  },
};
